import { render } from "./Gank.vue?vue&type=template&id=597d65e6&scoped=true"
import script from "./Gank.vue?vue&type=script&lang=js"
export * from "./Gank.vue?vue&type=script&lang=js"

import "./Gank.vue?vue&type=style&index=0&id=597d65e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597d65e6"]])

export default __exports__